import { lazy } from 'react';
import Loadable from '@/components/base-component/Loadable';
import PagesLayout from '@/layout/Pages';

//============ Page Components ===============
// งบวิจัย - Research Budget
const Dashboard = Loadable(lazy(() => import('@/pages/dashboard/dashboard-user')));
// const ResearchBudget = Loadable(lazy(() => import('@/pages/dashboard/research-budget')));
const UserResearch = Loadable(lazy(() => import('@/pages/dashboard/latex-purchase-my-order')));
const SummaryReport = Loadable(lazy(() => import('@/pages/dashboard/latex-report-user/customer-summary')));
// ::: ลำดับชั้นของ Path จะต้องเรียงลำดับให้ตรงในรายการ allowUsers List -->
// ::: ที่อยู่ของรายการ allowUsers List ==> /src/components/bs-component/menu-items/users
export const reseachUserRoutes = [
  {
    path: 'dashboard', // ไม่ต้องมี "/"
    element: <Dashboard />
  },
  {
    path: 'my-order', // ไม่ต้องมี "/"
    element: <PagesLayout />,
    children: [
      {
        path: 'list', // ไม่ต้องมี "/"
        element: <UserResearch />
      },
      {
        path: 'my-summary', // ไม่ต้องมี "/"
        element: <SummaryReport />
      }
    ]
  }
];
